import "../../scss/modules/_lazyframe.sass";
import lazyframe from "lazyframe";

let iframes = document.querySelectorAll('.lazyframe');
if (iframes) {
  lazyframe(iframes, {
    debounce: 250,
    lazyload: true
  });
}